import {connect} from 'react-redux';
import Component from './Component'
import _ from 'lodash';

export default connect(
  (state) => ({
    clipping: _.get(state, 'collection.globalIds'),
    canClipping: _.get(state, 'me.permission.clipping.isOpen'),
    permission: _.get(state, 'me.permission.projectSubject'),
    me: _.get(state, 'me'),
    isOpen: _.get(state, 'me.permission.monitoringSubject.isOpen')
  })
)(Component);



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/components/Container.js
 **/